
import { defineComponent } from "vue";

export default defineComponent({
  name: "Button",
  props: {
    variant: {
      type: String,
      validator(value: string) {
        return ["primary", "secondary", "disabled"].includes(value);
      },
    },
    disabled: Boolean,
  },
});
